import React from "react"
import Contact from "../components/contact"
import { Helmet } from "react-helmet"
import Layout from "../components/layout"
import config from "../lib/config"

export default function Example() {
  return (
    <Layout>
      <Helmet>
        <title>Request a Demo &mdash; {config.siteTitle}</title>
      </Helmet>
      <Contact />
    </Layout>
  )
}
